import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import SocieteInformation from "../../../ui/SocieteInformation";
import SocieteZoneTable from "./SocieteZoneTable";
import ZoneService from "../../../services/Zone";
import withLoader from "../../../components/layouts/WithLoader";

const SocieteByZone = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const location = useLocation(); // To access query parameters
  const [zones, setZones] = useState([]);
  const [informationModel, setInformationModel] = useState();
  const [onShowInformationModel, setOnShowInformationModel] = useState(false);
  // Extract the "id" from the query parameters
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");

  useEffect(() => {
    const fetchZone = async () => {
      try {
        startLoading();
        const response = await ZoneService.getSocietesByZone(id);
        console.log(response.data);
        setZones(response.data.success);
      } catch (error) {
        console.error("Error fetching zone:", error);
      } finally {
        stopLoading();
      }
    };

    console.log("Zone ID:", id); // Log the extracted ID
    if (id) {
      fetchZone();

    }
  }, [id]); // Add "id" to the dependency array if it might change

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <SocieteZoneTable listZones={zones} idZone={id} />
            </div>
          </div>
        </div>
      </div>

      {onShowInformationModel && (
        <SocieteInformation
          setOnShowInformationModel={setOnShowInformationModel}
          informationModel={informationModel}
        />
      )}
    </div>
  );
};

export default withLoader(SocieteByZone);
